export enum Action {
  UpdatePreparatoryQuery = 'searchQuery/UPDATE_PREPARATORY_QUERY',
  SetPreparatoryQuery = 'searchQuery/SET_PREPARATORY_QUERY',
  ApplyQuery = 'searchQuery/APPLY_QUERY',
  ResetPreparatoryQuery = 'searchQuery/RESET_PREPARATORY_QUERY',
}
